import styled from "styled-components";
import Slider from "../../../../../structures/others/slider/index.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const LastNews = styled.div.withConfig({
    displayName: "styled__LastNews",
    componentId: "sc-9566c40c-0"
})`
	box-shadow:
		0 1px 3px ${(props)=>props.theme.colors.black.higher},
		0 1px 2px ${(props)=>props.theme.colors.black.high};
	${FlexMixin({
    align: 'center'
})}
	background-color: ${({ theme  })=>theme.colors.white.base};
	border-radius: 4px;
	position: relative;
`;
export const SliderNews = styled(Slider).withConfig({
    displayName: "styled__SliderNews",
    componentId: "sc-9566c40c-1"
})`
	.splide__arrows {
		${FlexMixin({
    justify: 'end'
})}
		margin-left: 50px;
	}
	.splide__slide {
		width: auto !important;
	}
`;
export const SliderContent = styled.div.withConfig({
    displayName: "styled__SliderContent",
    componentId: "sc-9566c40c-2"
})`
	width: 85%;
`;
export const TitleIcon = styled.p.withConfig({
    displayName: "styled__TitleIcon",
    componentId: "sc-9566c40c-3"
})``;
export const DateNew = styled.span.withConfig({
    displayName: "styled__DateNew",
    componentId: "sc-9566c40c-4"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    weight: 'regular'
})}
	padding-right: 8px;
`;
export const Link = styled.a.withConfig({
    displayName: "styled__Link",
    componentId: "sc-9566c40c-5"
})`
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	position: relative;
	color: ${({ theme  })=>theme.colors.grays.darker};
	padding: 18px 0 19px 20px;
`;
export const More = styled.span.withConfig({
    displayName: "styled__More",
    componentId: "sc-9566c40c-6"
})`
	color: ${({ theme  })=>theme.colors.primary.light};
	font-weight: 400;
	padding-right: 20px;
`;
export const Text = styled.span.withConfig({
    displayName: "styled__Text",
    componentId: "sc-9566c40c-7"
})`
	padding-right: 5px;
`;
export const Items = styled.div.withConfig({
    displayName: "styled__Items",
    componentId: "sc-9566c40c-8"
})``;
export const Divider = styled.span.withConfig({
    displayName: "styled__Divider",
    componentId: "sc-9566c40c-9"
})``;
export const Icon = styled.div.withConfig({
    displayName: "styled__Icon",
    componentId: "sc-9566c40c-10"
})`
	${FlexMixin({
    align: 'center'
})}
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'regular'
})}
	background-color: ${({ theme  })=>theme.colors.primary.base};
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
	color: ${({ theme  })=>theme.colors.white.base};
	padding: 18px 16px 19px;
	width: 11%;
	.nico-newspaper {
		font-size: 26px;
		margin-right: 8px;
	}
`;

//# sourceMappingURL=styled.js.map